import { render, staticRenderFns } from "./ExamExercise.vue?vue&type=template&id=3a70e8d1&scoped=true&"
import script from "./ExamExercise.vue?vue&type=script&lang=js&"
export * from "./ExamExercise.vue?vue&type=script&lang=js&"
import style0 from "./ExamExercise.vue?vue&type=style&index=0&id=3a70e8d1&prod&scoped=true&lang=scss&"
import style1 from "./ExamExercise.vue?vue&type=style&index=1&id=3a70e8d1&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a70e8d1",
  null
  
)

export default component.exports